import { useToken } from '@ori/auth';
import { ApiClientProvider } from '@ori/global-api-client-react';
import { SWRConfig } from 'swr';
import { I18nLocalizationsLoader } from "./I18nLocalizationsLoader";
import { ConfigurationProvider, PersonalBeautyStoreProvider } from "../contexts";
import { useCookieToUrl } from "../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
export var PbsApp = function PbsApp(_ref) {
  var children = _ref.children,
    configuration = _ref.configuration,
    setQueryParameter = _ref.setQueryParameter,
    removeQueryParameter = _ref.removeQueryParameter;
  useCookieToUrl(setQueryParameter && removeQueryParameter ? {
    setQueryParameter: setQueryParameter,
    removeQueryParameter: removeQueryParameter
  } : undefined);
  var _useToken = useToken(),
    formattedToken = _useToken.formattedToken;
  return /*#__PURE__*/_jsx(ConfigurationProvider, {
    value: configuration,
    children: /*#__PURE__*/_jsx(SWRConfig, {
      value: {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        shouldRetryOnError: false,
        errorRetryCount: 0
      },
      children: /*#__PURE__*/_jsx(ApiClientProvider, {
        baseUrl: configuration.globalApiUrl,
        tenant: configuration.tenant,
        language: configuration.currentLanguage,
        token: formattedToken,
        children: /*#__PURE__*/_jsx(PersonalBeautyStoreProvider, {
          children: /*#__PURE__*/_jsx(I18nLocalizationsLoader, {
            children: children
          })
        })
      })
    })
  });
};